import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from "@material-ui/core";
import React, { useState } from "react";
import { TipTapReportDownload } from "./TipTapReportDownload";
import CloseIcon from "@material-ui/icons/Close";
import { useReportIDImagesDownloadList } from "../../../../common/CommonMutations";

export const TipTapReportDialog = ({ open, handleClose, editor, workorder }: any) => {
  // const data = {
  //   report_id: 264,
  //   report_number: "10054619",
  //   workorders: [
  //     {
  //       workorder_id: 163,
  //       workorder_name: "1",
  //       details: [
  //         {
  //           serial_numbers: "SKB1P413S17C210335",
  //           procedures: [
  //             {
  //               procedure_name: "Pre-Stress",
  //               procedure_definition_details: [
  //                 {
  //                   procedure_definition_id: 2,
  //                   procedure_definition_name: "Visual Inspection",
  //                   images: [
  //                     {
  //                       image_id: 1,
  //                       image_name: "visual_1.jpg",
  //                       image_url: "https://haveblueazdev.blob.core.windows.net/testmedia1/leads/25a85282-5205-429c-bde3-ca0b416df32d_Screenshot (35).png",
  //                     },
  //                     {
  //                       image_id: 2,
  //                       image_name: "visual_2.jpg",
  //                       image_url: "https://haveblueazdev.blob.core.windows.net/testmedia1/leads/25a85282-5205-429c-bde3-ca0b416df32d_Screenshot (35).png",
  //                     },
  //                   ],
  //                 },
  //                 {
  //                   procedure_definition_id: 3,
  //                   procedure_definition_name: "Wet Leakage Current Test",
  //                   images: [],
  //                 },
  //                 {
  //                   procedure_definition_id: 12,
  //                   procedure_definition_name: "EL Image at 1.0x Isc",
  //                   images: [
  //                     {
  //                       image_id: 3,
  //                       image_name: "el_image_1.jpg",
  //                       image_url: "https://example.com/images/el_image_1.jpg",
  //                     },
  //                   ],
  //                 },
  //                 {
  //                   procedure_definition_id: 21,
  //                   procedure_definition_name: "I-V Curve at STC (Front)",
  //                   images: [
  //                     {
  //                       image_id: 4,
  //                       image_name: "iv_front.png",
  //                       image_url: "https://example.com/images/iv_front.png",
  //                     },
  //                   ],
  //                 },
  //                 {
  //                   procedure_definition_id: 33,
  //                   procedure_definition_name: "I-V Curve at STC (Rear)",
  //                   images: [],
  //                 },
  //               ],
  //             },
  //           ],
  //         },
  //         {
  //           serial_numbers: "SKB1P413S17C210336",
  //           procedures: [
  //             {
  //               procedure_name: "Pre-Stress",
  //               procedure_definition_details: [
  //                 {
  //                   procedure_definition_id: 2,
  //                   procedure_definition_name: "Visual Inspection",
  //                   images: [
  //                     {
  //                       image_id: 1,
  //                       image_name: "visual_1.jpg",
  //                       image_url: "https://example.com/images/visual_1.jpg",
  //                     },
  //                     {
  //                       image_id: 2,
  //                       image_name: "visual_2.jpg",
  //                       image_url: "https://example.com/images/visual_2.jpg",
  //                     },
  //                   ],
  //                 },
  //                 {
  //                   procedure_definition_id: 3,
  //                   procedure_definition_name: "Wet Leakage Current Test",
  //                   images: [],
  //                 },
  //                 {
  //                   procedure_definition_id: 12,
  //                   procedure_definition_name: "EL Image at 1.0x Isc",
  //                   images: [
  //                     {
  //                       image_id: 3,
  //                       image_name: "el_image_1.jpg",
  //                       image_url: "https://example.com/images/el_image_1.jpg",
  //                     },
  //                   ],
  //                 },
  //                 {
  //                   procedure_definition_id: 21,
  //                   procedure_definition_name: "I-V Curve at STC (Front)",
  //                   images: [
  //                     {
  //                       image_id: 4,
  //                       image_name: "iv_front.png",
  //                       image_url: "https://example.com/images/iv_front.png",
  //                     },
  //                   ],
  //                 },
  //                 {
  //                   procedure_definition_id: 33,
  //                   procedure_definition_name: "I-V Curve at STC (Rear)",
  //                   images: [],
  //                 },
  //               ],
  //             },
  //           ],
  //         },
  //         {
  //           serial_numbers: "SKB1P413S17C210337",
  //           procedures: [
  //             {
  //               procedure_name: "Pre-Stress",
  //               procedure_definition_details: [
  //                 {
  //                   procedure_definition_id: 2,
  //                   procedure_definition_name: "Visual Inspection",
  //                   images: [
  //                     {
  //                       image_id: 1,
  //                       image_name: "visual_1.jpg",
  //                       image_url: "https://example.com/images/visual_1.jpg",
  //                     },
  //                     {
  //                       image_id: 2,
  //                       image_name: "visual_2.jpg",
  //                       image_url: "https://example.com/images/visual_2.jpg",
  //                     },
  //                   ],
  //                 },
  //                 {
  //                   procedure_definition_id: 3,
  //                   procedure_definition_name: "Wet Leakage Current Test",
  //                   images: [],
  //                 },
  //                 {
  //                   procedure_definition_id: 12,
  //                   procedure_definition_name: "EL Image at 1.0x Isc",
  //                   images: [
  //                     {
  //                       image_id: 3,
  //                       image_name: "el_image_1.jpg",
  //                       image_url: "https://lsdbhaveblueuat.azurewebsites.net/api/1.0/azure_files/203969/download/",
  //                     },
  //                   ],
  //                 },
  //                 {
  //                   procedure_definition_id: 21,
  //                   procedure_definition_name: "I-V Curve at STC (Front)",
  //                   images: [
  //                     {
  //                       image_id: 4,
  //                       image_name: "iv_front.png",
  //                       image_url: "https://example.com/images/iv_front.png",
  //                     },
  //                   ],
  //                 },
  //                 {
  //                   procedure_definition_id: 33,
  //                   procedure_definition_name: "I-V Curve at STC (Rear)",
  //                   images: [],
  //                 },
  //               ],
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // };

  console.log(editor);


  const { data: projectsList, isLoading } = useReportIDImagesDownloadList(workorder);



  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <Grid container alignItems="center">
            <Grid item xs={11}>
              Report ID : { }
            </Grid>
            <Grid item xs={1} style={{ textAlign: "right" }}>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          {isLoading ? (
            <Grid container justifyContent="center" style={{ padding: 30 }}>
              <CircularProgress />
            </Grid>
          ) : (
            <TipTapReportDownload
              data={projectsList?.workorders ?? []}
              editor={editor}
              handleClose={handleClose}
            />
          )}
        </DialogContent>

        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};
